import { render, staticRenderFns } from "./platformtab.vue?vue&type=template&id=96d9a974&scoped=true&"
import script from "./platformtab.vue?vue&type=script&lang=js&"
export * from "./platformtab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d9a974",
  null
  
)

export default component.exports